export default __webpack_public_path__ + "static/media/Lost Soul of Jovus.2b359007.jpg";